import React from "react";
import { isNull, isNumber, isUndefined } from "lodash";

import { useTranslation } from "@root/misc/useTranslation";

import { LineupOption } from "../types";

import { useStatsLinkOnClick } from "./Slot";

interface StatsEntryProps {
  type: "scoreSum" | "prevScore" | "percPicked";
  value: number;
}

const StatsEntry = ({ type, value }: StatsEntryProps) => {
  const valueClassName = [
    "neo__lineupSlot__statsBlock__entryText",
    value < 0 && "neo__lineupSlot__statsBlock__entryText--negative",
  ].join(" ");

  return (
    <div className="neo__lineupSlot__statsBlock__entry">
      <span
        className={`neo__lineupSlot__statsBlock__entryIcon neo__lineupSlot__statsBlock__entryIcon--${type}`}
      />
      <span className={valueClassName}>{value}</span>
    </div>
  );
};

interface StatsLinkProps {
  option: LineupOption;
}

export const StatsLink = ({ option }: StatsLinkProps) => {
  const { t } = useTranslation();

  const openLinkAndPreventPropagation = useStatsLinkOnClick(option);

  return (
    <span
      onClick={openLinkAndPreventPropagation}
      className="neo__lineupSlot__statsLink"
    >
      <span>{t("lineup.action_show_athlete_stats")}</span>
    </span>
  );
};

const hasStats = (option: LineupOption) => {
  return (
    isNumber(option.stat_perc_picked) ||
    isNumber(option.stat_prev_score) ||
    isNumber(option.stat_score_sum)
  );
};

interface StatsBlockProps {
  option: LineupOption;
}

export const StatsBlock = ({ option }: StatsBlockProps) => {
  if (!hasStats(option)) {
    return null;
  }

  return (
    <div className="neo__lineupSlot__statsBlock">
      {isNumber(option.stat_score_sum) && (
        <StatsEntry type="scoreSum" value={option.stat_score_sum} />
      )}
      {isNumber(option.stat_prev_score) && (
        <StatsEntry type="prevScore" value={option.stat_prev_score} />
      )}
      {isNumber(option.stat_perc_picked) && (
        <StatsEntry type="percPicked" value={option.stat_perc_picked} />
      )}
    </div>
  );
};
